let routes = [
  {
    path: '/demande-permis-psychotherapeute',
    component: () => import('../views/DemandePermisPsychotherapeute.vue'),
    props: true
  },
  {
    path: '/demande-permis-psychotherapeute/:step',
    component: () => import('../views/DemandePermisPsychotherapeute.vue'),
    props: true
  }
]

export default routes;